import React, { ReactElement } from 'react';
import styled from 'styled-components';
import ReactIcon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';

import { Box, Flex, Typography } from 'components';
import { useBadges } from 'features/badges';
import { Link } from 'react-router-dom';
import { createUrl } from 'app/utils';

const Wrapper = styled(Flex)``;

const BadgeImage = styled('img')`
  display: block;
  width: 75px;
  height: 75px;
  background: lightgray;
  border-radius: 50%;
`;

const BadgeButtonIcon = styled(ReactIcon)`
  width: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

const BadgeLink = styled(Link)`
  display: flex;
  flex-grow: 1;
`;

const BadgeButton = styled('button')`
  position: relative;
  flex-grow: 1;
  padding: 0;
  border: 0;
  text-align: left;
  margin: 0;
  padding: 15px 20px 10px 20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: ${({ theme }) => theme.colors.primary_400};
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  background: ${({ theme }) => theme.colors.gray_100};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.primary_400};
    color: white;

    ${BadgeButtonIcon} {
      color: white;
    }
  }
`;

const LastBadges = (): ReactElement => {
  const { studentBadges } = useBadges();

  return studentBadges && studentBadges.length ? (
    <Wrapper width={{ d: 450 }} flexGrow={0} flexShrink={0} bg="white" flexDirection="column" borderRadius={4}>
      <Flex pt={{ m: 20 }} pb={{ m: 20 }} px={{ m: 20 }} flexDirection="column">
        <Typography fontWeight="bold">Suas últimas conquistas</Typography>
      </Flex>

      <Flex flexGrow={0} width={{ d: 380 }} mx="auto" pb={{ m: 15 }}>
        {studentBadges.map((badge, index) => (
          <Box title={badge.name} flexGrow={0} width={75} height={75} m={{ m: '10px' }} key={`badge-${badge.uuid}`}>
            <BadgeImage src={badge.imageUrl} alt={badge.name} />
          </Box>
        ))}
      </Flex>

      <BadgeLink to={createUrl('myBadges')}>
        <BadgeButton>
          Ver minhas conquistas
          <BadgeButtonIcon path={mdiArrowRight} />
        </BadgeButton>
      </BadgeLink>
    </Wrapper>
  ) : (
    <></>
  );
};
export default LastBadges;
